import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { BookOpen, Home } from "lucide-react";

const TenantNotFoundPage = () => {
  const hostname = window.location.hostname;
  const subdomain = hostname.split(".")[0];

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/20 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <BookOpen className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
          <h1 className="text-4xl font-bold mb-2">404</h1>
          <h2 className="text-2xl font-semibold text-muted-foreground mb-4">Library Not Found</h2>
          <p className="text-muted-foreground mb-6">
            The library you're looking for doesn't exist or is no longer available.
            {subdomain && subdomain !== "www" && (
              <span className="block mt-2">
                Subdomain: <code className="bg-muted px-2 py-1 rounded">{subdomain}</code>
              </span>
            )}
          </p>
        </div>

        <div className="space-y-4">
          <Button asChild size="lg" className="w-full">
            <Link to="https://www.philolms.com">
              <Home className="h-4 w-4 mr-2" />
              Go to Main Platform
            </Link>
          </Button>
          <p className="text-sm text-muted-foreground">
            If you believe this is an error, please contact support.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TenantNotFoundPage;
